import * as React from 'react'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// context
import { PlanEditPageContext } from 'containers/Plan/Edit/layers/API'
// themes
import { colors } from 'themes'
// hooks
import { useShowModal } from 'hooks'
// constants
import { Modals } from 'constants/modals'

// constants
const BUTTON_STYLE = {
  color: colors.purple300,
  minWidth: '158px',
  height: '40px'
}

const CreateSubPlanButton: React.FC = () => {
  const { plan } = React.useContext(PlanEditPageContext)

  const { showModal } = useShowModal({ modalType: Modals.SUB_PLAN_CREATE_MODAL })

  const handleCreateClick = () => {
    showModal({ parentPlan: plan })
  }

  return (
    <Button
      shadowLess
      layout={BUTTON_LAYOUTS.DARK_BLUE}
      type={'submit'}
      style={BUTTON_STYLE}
      onClick={handleCreateClick}>
      CREATE SUB PLAN
    </Button>
  )
}

export default CreateSubPlanButton
